export function getSocialMetas({
	url,
	title = '',
	description = '',
	image,
	ogImageWidth = 1200,
	ogImageHeight = 630,
}: {
	image?: string
	ogImageWidth?: number
	ogImageHeight?: number
	url: string
	title?: string
	description?: string
}) {
	// prettier-ignore
	return [
		{ title },
		{ description },
		{ image },
		{ name: "og:url", content: url },
		{ name: "og:title", content: title },
		{ name: "og:description", content: description },
		{ name: "og:image", content: image },
		{ name: "og:image:width", content: ogImageWidth },
		{ name: "og:image:height", content: ogImageHeight },
		{
			name: "twitter:card",
			content: image ? "summary_large_image" : "summary",
		},
		//name:  "twitter:creator", content: "@winewithmargaret",
		//name:  "twitter:site", content: "@winewithmargaret",
		{ name: "twitter:title", content: title },
		{ name: "twitter:description", content: description },
		{ name: "twitter:image", content: image },
		{ name: "twitter:image:alt", content: title },
	]
}
